import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { MatDialog, MatDialogModule } from '@angular/material/dialog';

import Resources from '@constants/resourses';
import { environment } from '@environments/environment';

import { LoginComponent } from '@shared/dialog/login/login.component';

import { SessionService } from '@services/session.service';
import { UtilityService } from '@services/utility.service';
import { AppService } from '@services/app.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, MatDialogModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];
  email: string;
  selectedQuote: any;
  isLoggedIn: boolean = false;

  constructor(
    public dialog: MatDialog,
    private utilityService: UtilityService,
    private sessionService: SessionService,
    private appService: AppService
  ) {
    this.isLoggedIn = this.utilityService.isLoggedIn();
    this.email = this.sessionService.getData(Resources.SessionStorageKeys.Email);
  }

  ngOnInit() {
    this.subscriptions.push(
      this.appService.getApplicationStatus().subscribe((data: any) => {
        if (data === 'update') {
          this.isLoggedIn = this.utilityService.isLoggedIn();
          this.email = this.sessionService.getData(Resources.SessionStorageKeys.Email);
          this.selectedQuote = this.sessionService.getItemFromSession(Resources.SessionStorageKeys.SelectedQuote);
        }
      })
    );
  }

  // onClick CompareTheMarket logo [TEAM] - Check with team regarding this functionality
  logo(): void {
    // Check if the environment is production
    if (environment.ENV === 'PROD') {
      // If it is, clear session storage and redirect to the production URL
      // this.sessionService.clearSessionStorage();
      window.open('https://comparethemarket.com/', '_self');
    } else {
      // Otherwise, clear session storage, remove quotes data from local storage, and redirect to the home URL
      // this.sessionService.clearSessionStorage();
      this.sessionService.removeData(Resources.SessionStorageKeys.QuotesData);
      window.open(environment.home_url, '_self');
    }
  }

  // onClick signIn and signOut buttons
  sign(state: boolean): void {
    // If the state is true, call the signOut method
    if (state) {
      this.signOut();
    } else {
      // Otherwise, call the signIn method
      this.signIn();
    }
  }

  // signIn method
  signIn(): void {
    const dialogRef = this.dialog.open(LoginComponent, {
      data: { placement: 'header_sign_in', target: 'login' },
      width: '570px',
      maxWidth: window.innerWidth <= 767 ? '95vw' : '569px',
      disableClose: true,
      autoFocus: false,
      panelClass: 'ctm-modal'
    });

    // After the dialog is closed, check the result
    dialogRef.afterClosed().subscribe(result => {
      if (!result) {
        // Closed loggedIn popup
        this.isLoggedIn = this.utilityService.isLoggedIn();
        this.email = this.sessionService.getData(Resources.SessionStorageKeys.Email);
        this.selectedQuote = this.sessionService.getItemFromSession(Resources.SessionStorageKeys.SelectedQuote);
      }
    });
  }

  // signOut method
  signOut(): void {
    // Update sessionData with user state
    this.subscriptions.push(
      this.sessionService.putSessionData(this.sessionService.getItemFromSession(Resources.SessionStorageKeys.CorrelationId), {
        user_loggedin: false
      }).subscribe({
        next: (res) => {
          this.sessionService.removeItemFromSession(Resources.SessionStorageKeys.IsRetry);
          this.isLoggedIn = false;
          // Call the signingOut method from the utility service
          this.utilityService.signingOut();
          // Reset the application status to initial state
          this.appService.resetApplicationStatus();
        }, error: (err) => {
          console.log('Error updating session data:', err);
          this.isLoggedIn = false;
          // Call the signingOut method from the utility service
          this.utilityService.signingOut();
          // Reset the application status to initial state
          this.appService.resetApplicationStatus();
        }
      })
    );
      
    this.isLoggedIn = false;
    // Call the signingOut method from the utility service
    this.utilityService.signingOut();
    // Reset the application status to initial state
    this.appService.resetApplicationStatus();
  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }
}
